import { requestGet } from '@/common/request';

export interface saleSelectionRes {
  ret: string;
  msg: string;
  data: any;
}

// 活动盘品-获取促销选品配置信息
export default async function goodsGroupDel(query: { groupCodes: string[] }): Promise<RequestResult<{}>> {
  return await requestGet('/goodsGroup/del', query);
}
